<template>
    <div class="tel-wind form">
        <div class="tel-wind__header d-flex jc-sb">
            <p class="tel-wind__title d-flex ai-end">
                Телефония
                <span>Агент {{agentName}}</span>
            </p>
            <div class="d-flex jc-end gat-8">
                <v-button class="button button_with_icon button_type_icon button_color_transp-black" 
                    :class="{'button_type_disabled': !isCanMakeNoice}"    
                    :title="isCanMakeNoice ? 'включен' : 'отключен'"
                    @click="$emit('action', {action:'ring'})"
                >
                    <svg aria-hidden="true" width="20" height="20">
                        <use href="#icon-bell"></use>
                    </svg>
                </v-button>
                <button class="button button_with_icon button_type_icon button_color_transp-black" @click="$emit('close')">
                    <svg aria-hidden="true" width="20" height="20">
                        <use href="#icon-close"></use>
                    </svg>
                </button>
            </div>
        </div>
        <div class="tel-wind__row">
            <v-tel-input @action="$emit('action', $event)" :isValidate="validate" :validate="agentName"/>
        </div>
        <transition name="grow-in-out" >
            <div class="tel-wind__row" :key="'title'" v-if="answeredList && answeredList.length">
                <p class="tel-wind__subtitle">
                    <template v-if="answeredList.length == 1">
                        Текущий звонок 
                    </template>
                    <template v-if="answeredList.length > 1">
                        Текущие звонки
                    </template>
                </p>
            </div>
        </transition> 
        <div class="tel-wind__row">
            <transition-group name="grow-in-out" tag="div" class="tel-list form">
                    <v-current-call 
                        :key="item.id" v-if="answeredList && answeredList.length" v-for="item in answeredList"
                        :value="item"
                        @action="$emit('action', $event)"
                        :isValidate="validate"
                        :agentName="agentName"
                    />
            </transition-group>
        </div>

        <div class="tel-wind__row">
            <p class="tel-wind__subtitle">
                Входящие
            </p>
        </div>
        <div class="tel-wind__row">
            <v-incoming-callList v-model="callList" :disabled="!!(answeredList && answeredList.length)" @action="$emit('action', $event)"/>
        </div>
        <div class="tel-wind__row">
            <v-status-switcher />
        </div>
    </div>
</template>

<script>

import vIncomingCallList from './IncCallList'
import vButton from '@components/global/vButton'
import vCurrentCall from './currentCall'
import vTelInput from './TelInput'
import vCheckBox from '@components/global/CheckBox'
import vStatusSwitcher from './statusSwitcher'
export default {
    name: 'TelWind',
    props: {
        agentName: {
            type: String,
            default: ''
        },
        value: {
            type: Object,
            default: () => {}
        },
        callList: {
            type: Array,
            default: () => []
        },
        answeredList: {
            type: Array,
            default: () => []
        },
        isCanMakeNoice: {
            type: Boolean,
            default: true
        }
    },
    components: {
        vTelInput,
        vIncomingCallList,
        vButton,
        vCurrentCall,
        vCheckBox,
        vStatusSwitcher
    },
    data() {
        return {
            timer: null,
            isloading: true,
            validate: true
        }
    },
    methods: {
    }
}
</script>

<style lang="scss" >
@import '@scss/mixins.scss';
@import '@scss/variables.scss';
.tel-wind {
    display: flex;
    width: 378px;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    flex-shrink: 0;
    border-radius: 12px;
    background: #FFF;
    
    /* Sidebar left */
    box-shadow: 4px 0px 12px 0px rgba(58, 65, 70, 0.06), 8px 0px 16px 0px rgba(58, 65, 70, 0.12);
    &__header {
        display: flex;
        align-items: center;
        width: 100%;
        .button {
            margin-left: auto;
        }
    }
    
    &__title { 
        display: flex;
        align-items: center;
        color: #0A0A17;
        font-size: 24px;
        font-weight: 600;
        line-height: 32px;
        span {
            color: #919197;
            font-size: 14px;
            font-weight: 600;
            line-height: 18px;
            margin-left: 12px;
        }
    }
    
    &__subtitle {
        color: #0A0A17;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
    }
    
    &__row {
        width: 100%;
    }
    
    &__input {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        input {
            font-size: 14px;
        }
    }
    
    & &__call {
        color: #30C66C;
        margin-left: 20px;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        &-active {
            color: #e94a4a;
        }
        svg {
            margin: 0;
        }
        &.button_type_loading { span { display: none; } }
        .preloader {
            margin: 0;
        }
        &-preload {
            color: #fff;
            background-color: #30C66C;
            border-radius: 50%;
        }
        
        &-disabled { 
            color: #ccc;
        }
        
    }
}

@keyframes shrink {
  to {
    width: 0; /* конечная ширина */
  }
}
.tel-list {
    &__item {
        width: 100%;
    }
    &__timer {
        background-color: #3a4146;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        height: 5px;
        &:after{
            content: '';
            display: block;
            background-color: #f9c30c;
            height: 100%;
            animation: shrink 5s linear forwards;
            width: 100%;
        }
    }
    &__items {
        
        display: block;
        max-height: 330px;
        overflow: auto;
        @include scrollbar();
        padding-right: 10px;
        margin-right: -10px;
    }
    
    p {
        color: #919197;
        font-size: 14px;
        font-weight: 600;
        line-height: 18px;
    }
    &__item {
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 12px 20px;
        border-radius: 12px;
        border: 1px solid #CBCCCF;
        box-shadow: 0px 8px 24px 0px rgba(58, 65, 70, 0.06), 0px 4px 8px 0px rgba(58, 65, 70, 0.06);
        overflow: hidden;
        //height: 71px;
        margin-bottom: 12px;
        &:last-child {
            margin-bottom: 0;
        }
    }

    &__item-transferring {
        background-color: #f9c30c;
    }

    &__item-rage {
        background-color: lighten($global-rage, 30%);
    }

    &__item-green {
        background-color: lighten($global-green, 30%);
    }
    
    &__name {
        *,a {
            color: #919197;
            font-size: 14px;
            font-weight: 600;
        }
    }
    &__number {
        display: flex;
        align-items: flex-end;
        color: #3A4146;
        font-size: 16px;
        font-weight: 600;
        line-height: 20px;
        &-centered { 
            margin-top: auto;
            margin-bottom: auto;
            align-items: center;
        }
    }
    
    &__buttons{
        display: flex;
        margin-left: auto;
        gap: 12px;
        button {
            margin-right: 0;
            svg {
                margin-left: 0;
                margin-right: 0;
            }
        }
    }
    & &__button {
        color: #30C66C;
        &-red {
            color: #E94A4A;
        }
    }
}
</style>